export default "__VITE_ASSET__CIpBXF0r__"